<template>
  <div class="testv__benefit__card__wrapper">
    <div class="testv__benefit__card__bg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" class="corner">
        <path d="M0,4c0-2.2091,0-4,0-4h100v100H59.6467c-1.0548,0-2.067-0.417-2.8161-1.159L1.1838,43.674
          C0.4262,42.923,0,41.9,0,40.833V4z"/>
      </svg>
    </div>
    <div class="testv__benefit__card">
      
      <div class="testv__benefit__card__left">
        <div class="testv__benefit__card__name" v-html="benefit.name"></div>
      </div>
      <div class="testv__benefit__card__right">
        <div class="testv__benefit__card__intro" v-html="benefit.intro"></div>
        <SsButton2
          class="testv__benefit__card__btn"
          @click="open">
          <components v-if="benefit.button.icon" :is="benefit.button.icon" class="testv__benefit__card__btn__icon"/>
          <span>{{ benefit.button.text }}</span>
        </SsButton2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestvBenefitCard',

  props: {
    benefit: Object
  },

  methods: {
    open () {
      if (!this.benefit.button || !this.benefit.button.link) return
      this.$openLink(this.benefit.button.link)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.testv__benefit__card__wrapper {
  position: relative;
}
.testv__benefit__card {
  width: 100%;
  min-height: 110px;
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 20px;
  .testv__benefit__card__name {
    white-space: pre-wrap;
    font-size: 32px;
    font-weight: 600;
    @media (min-width: $screen-md) {
      font-size: 40px;
    }
  }
  .testv__benefit__card__intro {
    font-size: 15px;
    color: var(--dark-bwb-6);
    >>> p {
      margin: 24px 0;
      &:first-child {
        margin-top: 0;
      }
    }
    >>> img {
      width: 100%;
      border-radius: 4px;
    }
  }
  .testv__benefit__card__right {
    width: 152px;
    @media (min-width: $screen-md) {
      width: 188px;
    }
  }
  .testv__benefit__card__btn {
    width: 100%;
    height: 40px;
    background: var(--yellow-testv);
    color: var(--dark-bwb-0);
    border-radius: 4px;
    font-size: 17px;
    font-weight: 500;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 8px;
    margin-top: 8px;
    .testv__benefit__card__btn__icon {
      width: 20px;
      height: 20px;
    }
    &:disabled {
      opacity: 0.5;
    }
  }
}

.testv__benefit__card__bg {
  color: var(--dark-bwb-2);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 0;
  .corner {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100px;
    height: 100px;
  }
  &::before {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    top: 0;
    bottom: 100px;
    background: var(--dark-bwb-2);
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    left: 100px;
    right: 0;
    bottom: 0;
    height: 100px;
    background: var(--dark-bwb-2);
    border-bottom-right-radius: 4px;
  }
}
</style>
